import { useCallback, useEffect, useRef, useState } from "react";

/**
 * Runs `fetcher` whenever `deps` change. Ignores stale responses and keeps the
 * previous data on screen while reloading, so charts do not flash empty.
 */
export const useReportData = (fetcher, deps, onData) => {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const sequence = useRef(0);
  const onDataRef = useRef(onData);
  onDataRef.current = onData;

  const load = useCallback(async () => {
    const id = ++sequence.current;
    setState((current) => ({ ...current, loading: true, error: null }));
    try {
      const data = await fetcher();
      if (id !== sequence.current) return;
      setState({ data, loading: false, error: null });
      if (onDataRef.current) onDataRef.current(data);
    } catch (error) {
      if (id !== sequence.current) return;
      setState({
        data: null,
        loading: false,
        error:
          error?.response?.data?.message || error?.message || "Unable to load this report.",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  useEffect(() => {
    load();
  }, [load]);

  return { ...state, reload: load };
};
